const SMALL_WORDS = new Set(["in", "of", "and", "the", "a", "an", "on", "to", "vs"]);

// Display-only: "backRankMate" / "back_rank_mate" -> "Back Rank Mate"
export function formatThemeLabel(raw) {
  if (!raw) return "";
  return String(raw)
    .replace(/[_-]+/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([a-zA-Z])(\d)/g, "$1 $2")
    .trim()
    .split(/\s+/)
    .map((w, i) => {
      const lw = w.toLowerCase();
      if (i > 0 && SMALL_WORDS.has(lw)) return lw;
      return lw.charAt(0).toUpperCase() + lw.slice(1);
    })
    .join(" ");
}

const STAGE_LABELS = { engine: "Chess engine", parse: "Reading your PGN", llm: "AI coach" };

export function formatStageError(e, fallback) {
  const d = e?.response?.data;
  if (d?.stage && d?.message) return `${STAGE_LABELS[d.stage] || d.stage}: ${d.message}`;
  if (typeof d?.detail === "string") return d.detail;
  if (!e?.response) return "Couldn't reach the server — check your connection and try again.";
  if (e.response.status >= 502) return "The server took too long to respond — please try again in a moment.";
  return fallback;
}
